import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight, Zap } from 'lucide-react';

export function AlphaBanner() {
  const scrollToWaitlist = () => {
    const waitlistSection = document.getElementById('alpha-waitlist');
    if (waitlistSection) {
      waitlistSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.div
      className="bg-gradient-to-r from-purple-600 via-pink-600 to-orange-500 text-white py-3 px-4"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-center gap-4 text-center">
          <motion.div
            className="flex items-center gap-2"
            animate={{ 
              scale: [1, 1, 1],
            }}
            transition={{ 
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut" 
            }}
          >
            <span className="font-bold text-sm md:text-base">
              DigiTables Alpha is Here!
            </span>
          </motion.div>
          
          <div className="hidden md:flex items-center gap-2 text-sm">
            <Zap className="h-4 w-4" />
            <span>Early access • 100MB free</span>
          </div>
          
          <motion.button
            onClick={scrollToWaitlist}
            className="bg-white/20 hover:bg-white/30 backdrop-blur-sm px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 flex items-center gap-1"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Join Waitlist
            <ArrowRight className="h-3 w-3" />
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
}